import React from 'react';
import { Template, TemplateConnector, TemplatePlaceholder } from "@devexpress/dx-react-core";


class TableRowsIndexer extends React.PureComponent {

    render() {          
    
      return (
          <Template name="tableRow" predicate={({ tableRow }) => tableRow.type.toString() === 'Symbol(data)' && tableRow.row.HDR !== 1 && tableRow.row.OPTATIVA !== 1}>
            {({ tableRow, rows, ...restParams }) => (
              <TemplateConnector>
                {({ rows }) => {                      
                    
                  const rowIndex = rows.filter(x => x.groupedBy === undefined && x.HDR !== 1 && x.OPTATIVA !== 1).indexOf(tableRow.row);
                    
                  return (
                    <TemplatePlaceholder
                      params={{ rowIndex, tableRow, ...restParams }}
                    />
                  );

                }}
              </TemplateConnector>
            )}
          </Template>
      );
      
    
    }
}


export default TableRowsIndexer;